export const MODULE_PATH_OPEN_CITY = '';
